function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m29 27c.553 0 1 .447 1 1s-.447 1-1 1h-18c-.553 0-1-.447-1-1s.447-1 1-1zm-3.998-16c.55 0 .999.449.999 1v11.999c0 .551-.449 1-.999 1h-3.001c-.55 0-1-.449-1-1v-11.999c0-.551.45-1 1-1zm-7.0041 4c.552 0 1.003.451 1.003 1.003v7.993c0 .552-.451 1.003-1.003 1.003h-2.993c-.552 0-1.004-.451-1.004-1.003v-7.993c0-.552.452-1.003 1.004-1.003z",
  fillRule: "evenodd",
  transform: "translate(-10 -11)"
});

var SvgAlignBottom = function SvgAlignBottom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 20 18",
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlignBottom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/align-bottom.58f61665.svg";
export { ForwardRef as ReactComponent };